import { useState } from 'react';

import { useEffectOnce } from '@ardoq/hooks';
import { type I18nLocale, t } from '@ardoq/i18n';
import { LoadingOverlay } from '@ardoq/loader';

const LOADING_DELAY = 300;

const DashboardLoadingOverlay = ({
  message,
  i18nLocale,
}: {
  message?: string;
  i18nLocale: I18nLocale;
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffectOnce(() => {
    const timeOutId = setTimeout(() => setIsVisible(true), LOADING_DELAY);
    return () => clearTimeout(timeOutId);
  });
  const resolvedMessage =
    message ??
    t(i18nLocale, 'dashboard:loadingOverlay.message', 'Loading dashboard');
  return isVisible ? <LoadingOverlay message={resolvedMessage} /> : null;
};

export { DashboardLoadingOverlay };
